import { ChangeDetectionStrategy, Component, computed, inject, output } from "@angular/core";
import { ITab } from "@shared/models/tab";
import { AppConfigService } from "@api/services/app-config.service";
import { TokenService } from "@auth/services/token/token.service";
import { CentersService } from "@shared/services/api/centers/centers.service";
import { toSignal } from "@angular/core/rxjs-interop";
import { UserMenuPermissionsArgs, UserMenuComponent } from "@layout/components/user-menu/user-menu.component";
import { buttonPtOptions } from "@layout/components/topbar/button-pt-options";
import { TabsbarComponent } from "@layout/components/tabsbar/tabsbar.component";
import { HelpMenuComponent } from "@layout/components/help-menu/help-menu.component";

@Component({
    selector: "app-topbar",
    styleUrl: "./app.topbar.component.scss",
    templateUrl: "./app.topbar.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TabsbarComponent, HelpMenuComponent, UserMenuComponent],
})
export class AppTopBarComponent {
    public buttonPtOption = buttonPtOptions;

    public tabClicked = output<ITab>();
    public changeCentersClicked = output<null>();
    public logoutClicked = output<null>();
    public settingsClicked = output<null>();

    private readonly tokenService = inject(TokenService);
    private readonly centersService = inject(CentersService);
    private readonly appConfigService = inject(AppConfigService);

    public readonly token = this.tokenService.getToken();
    public readonly appConfig = this.appConfigService.appConfig;
    public readonly scopedCenter = this.centersService.scopedCenter;
    public readonly centers = toSignal(this.centersService.centers$, {
        initialValue: [],
    });

    public userMenuPermissionArgs = computed<UserMenuPermissionsArgs>(() => ({
        canAccessACC:
            this.tokenService.hasPermissions(["cmuser", "activitytracker"]) &&
            this.centers().some((c) => c.isACC_Enabled),
        canAccessACU: this.tokenService.hasPermissions(["costutil"]) && this.centers().some((c) => c.isACU_Enabled),
        isDRVSEnabled: this.centers().some((c) => c.isDRVS_Enabled),
        isACWAdmin: this.tokenService.hasPermissions(["acwadmin"]),
        isMultiCenter: this.centers().length > 1,
    }));

    handleTabClicked(tab: ITab) {
        this.tabClicked.emit(tab);
    }

    handleChangeCentersClicked() {
        this.changeCentersClicked.emit(null);
    }

    handleLogoutClicked() {
        this.logoutClicked.emit(null);
    }

    handleSettingsClicked() {
        this.settingsClicked.emit(null);
    }
}
